import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

const AnimationDuration = '300ms';

export interface IAnimationProps {
  children: React.ReactNode;
  isChildVisible?: boolean;
  initialChildVisibility?: 'visible' | 'hidden';
  height?: number | string;
}

export const Animation = (props: IAnimationProps) => {
  const [isAnimate, setIsAnimate] = useState<boolean>(false);
  const [isRendered, setIsRendered] = useState<boolean>(
    props.initialChildVisibility === 'visible' || props.initialChildVisibility === undefined
  );

  useEffect(() => {
    if (!isAnimate && isRendered && props.isChildVisible === false) {
      setIsAnimate(true);
    }

    if (!isAnimate && !isRendered && props.isChildVisible === true) {
      setIsRendered(true);
      setIsAnimate(true);
    }
  }, [props.isChildVisible]);

  return (
    <Box
      onTransitionEnd={() => {
        setIsAnimate(false);
        if (props.isChildVisible === false) {
          setIsRendered(false);
        }
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: getFinalHeight(props.isChildVisible, props.height),
        opacity: getFinalOpacity(props.isChildVisible),
        overflow: 'hidden',
        transition: `all ${AnimationDuration} ease-in`,
      }}
    >
      {isRendered && props.children}
    </Box>
  );
};

function getFinalHeight(isChildVisible: boolean | undefined, height?: number | string): number | string {
  if (height) {
    return isChildVisible ? height : 0;
  }
  return 'none';
}
function getFinalOpacity(isVisible: boolean | undefined): number {
  if (isVisible === undefined) {
    return 1;
  }
  return isVisible ? 1 : 0;
}
